import router from "@/router";
import { getVesselsDashboard } from "@/services/home2/service";

export const fleetModule = {
  namespaced: true,

  state: () => ({
    vessels: [],
    loading: false,
    error: null,
  }),

  mutations: {
    SET_LOADING(state, value) {
      state.loading = value;
    },

    SET_ERROR(state, value) {
      state.error = value;
    },

    SET_VESSELS(state, vessels) {
      state.vessels = vessels;
    },
  },

  getters: {
    vessels: (state) => state.vessels,
    isLoading: (state) => state.loading,
    error: (state) => state.error,
  },

  actions: {
    async fetchVesselsDashboard({ commit }) {
      commit("SET_LOADING", true);
      commit("SET_ERROR", null);

      try {
        const vessels = await getVesselsDashboard();
        commit("SET_VESSELS", vessels);
      } catch (error) {
        if (error.code === "rdr") {
          router.push("/login").catch(() => {});
        }

        commit("SET_VESSELS", []);
        commit("SET_ERROR", error.message || "Failed to fetch vessels dashboard");
      } finally {
        commit("SET_LOADING", false);
      }
    },
  },
};
